/* eslint-disable react/jsx-props-no-spreading */
import { Box, Divider, DividerProps, Skeleton } from '@mui/material';
import React from 'react';

export const SitesDivider: React.FC<DividerProps & { initializing?: boolean }> = ({ initializing, ...props }) => (
  <Box sx={{ width: '100%' }}>{initializing ? <Skeleton height="1px" /> : <Divider {...props} />}</Box>
);
